import { ImageHandlerInit } from './imageConfigService.types';
import ContentfulInput from './Adapters/contentful.input';
import BaseOutput from './Adapters/base.output';

const imageConfigService: ImageHandlerInit<any, any> = (inputParser, outputParser) => value => {
    return outputParser(inputParser(value));
};

const contentfulToBaseImage = imageConfigService(ContentfulInput, BaseOutput);

export default imageConfigService;
export { contentfulToBaseImage };
